export default {
  "nav.home": "Inicio",
  "nav.article": "Guía USFans",
  "nav.categories": "Categorías",
  "nav.faq": "Preguntas frecuentes",
  "nav.guides": "Guías",
  "nav.shoppingGuide": "Guía de compras",
  "nav.openSpreadsheet": "USFans Spreadsheet",

  "lang.label": "Idioma",

  "cta.exploreSpreadsheet": "Explorar USFans Spreadsheet",
  "cta.buyNow": "Cómpralo ahora",
  "cta.visitMain": "Visitar el sitio principal",
  "cta.browseGuides": "Ver guías de USFans",
  "cta.readArticle": "Leer la guía completa",
  "cta.openSpreadsheet": "Abrir USFans Spreadsheet",
  "cta.backHome": "Volver al inicio",

  "categories.title": "Explorar por categoría",
  "categories.subtitle": "Ve directo a una categoría de productos en el sitio principal",
  "categories.selectLabel": "Elige una categoría",
  "categories.placeholder": "Selecciona una categoría para continuar",
  "categories.all": "Todas las categorías",

  "categories.shoes": "Zapatos",
  "categories.hoodies": "Sudaderas/Suéteres",
  "categories.tshirts": "Camisetas",
  "categories.jackets": "Chaquetas",
  "categories.pants": "Pantalones/Shorts",
  "categories.headwear": "Gorras y sombreros",
  "categories.sets": "Conjuntos",
  "categories.underwear": "Ropa interior",
  "categories.jersey": "Camisetas deportivas",
  "categories.accessories": "Accesorios",
  "categories.bags": "Bolsos",
  "categories.belts": "Cinturones",
  "categories.perfumes": "Perfumes",
  "categories.other": "Otros artículos",

  "footer.tagline": "Un centro de recursos independiente para explorar USFans Spreadsheet y guías relacionadas.",
  "footer.disclaimer": "USFansLink.wiki es un recurso informativo independiente y no está necesariamente afiliado ni respaldado por USFans.",
  "footer.quickLinks": "Enlaces rápidos",
  "footer.categories": "Categorías",
  "footer.resources": "Recursos",
  "footer.language": "Idioma",
  "footer.rights": "Todos los derechos reservados.",
  "footer.about": "Acerca de",
  "footer.disclaimerLink": "Aviso legal",
  "footer.safety": "Centro de seguridad",
};